import React, { useState } from 'react';
import RoundedButton from '../../../../components/RoundedButton/RoundedButton';
import { Dropdown, Menu, Icon } from 'antd';
import cn from 'classnames';
import styles from './BuildReportDropdown.module.scss';
import { requestActionNames } from '../../constants/common';

const items = [{ id: requestActionNames.excel, name: 'Выгрузить в excel' }];

export const BuildReportDropdown = ({ className, disabled, onMenuClick }) => {
  const [visible, setVisible] = useState(false);

  const handleMenuClick = ({ key }) => {
    onMenuClick(key);
    setVisible(false);
  };

  const handleVisibleChange = (visible) => {
    setVisible(visible);
  };

  return (
    <Dropdown
      overlay={
        <Menu
          selectable={false}
          onClick={handleMenuClick}
        >
          {items.map((item) => (
            <Menu.Item key={item.id}>{item.name}</Menu.Item>
          ))}
        </Menu>
      }
      trigger={['click']}
      disabled={disabled}
      onVisibleChange={handleVisibleChange}
      visible={visible}
    >
      <RoundedButton
        iconRight={<Icon type="caret-down" />}
        text="Экспортировать"
        className={cn(styles.root, className)}
        invert
      />
    </Dropdown>
  );
};
